import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { UserService } from '../../../../services/user.service';
import { CyclistService } from '../../../../services/cyclist.service';
import { PartnerService } from '../../../../services/partner.service';
import { TechnicianService } from '../../../../services/technician.service';
import { HelpersService } from '../../../../services/helpers.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { CollectionsService } from '../../../../services/collections.service';

@Component({
  selector: 'app-edit-user-addresses',
  templateUrl: './edit-user-addresses.component.html',
  styleUrls: ['./edit-user-addresses.component.scss']
})
export class EditUserAddressesComponent {

  @Input() user;
  @Input() partnerId;
  @Input() cyclistView: boolean;
  @Input() messageService: MessageService;
  @Input() technicians; //Use this to when linking a technician to see if they exist before recreating them.
  @Output() update = new EventEmitter();
  @Output() canUpdate = new EventEmitter<boolean>();

  public showGDPRMarketingConsent: boolean = false;
  public isSuperUser: boolean = false;
  public busy: boolean = false;

  public customer: any = {};
  public collection: any = {};
  public address: any = {};
  public updating: boolean = false;
  public step: number = 1
  public addressSearch: any;
  public fullAddress: string = "";
  public partner: any;
  public addressOptions: any;
  public collectionAddrssLoading: boolean;
  public addresses = [];

  public addManually: boolean = true;
  public loading: boolean = true;  

  public street_no: string
  public street_address: string
  public city: string
  public country: string
  public postal_code: string
  public apartment: string

  public editing: boolean = false;
  public showAddressForm: boolean = false;
  public editingAddress: any = {};
  public errorLabel = "An address with this label already exists..";
  constructor(
    private fb: FormBuilder,
    private confirmationService: ConfirmationService,
    public helpersService: HelpersService,
    public userService: UserService,
    public cyclistService: CyclistService,
    public partnerService: PartnerService,
    public technicianService: TechnicianService,
    public modal: NgbActiveModal,
    private translate: TranslateService,
    private collectionsService: CollectionsService,
  ) {
    this.partner = helpersService.getPartnerData();
  }

  ngOnInit() {
    console.log(this.user);
    this.customer = this.user;
    this.isSuperUser = this.helpersService.getProfileData().IsSuperUser;
    this.partnerId = this.helpersService.getPartnerId();
    this.getAddresses();
    this.customer.AddressType = "";
    this.errorLabel = this.translate.instant('customer.addresses.label_already_exists');
    this.canUpdate.emit(true);
  }

  search(address) {
    this.addressSearch = address.query;
    this.address.googlePlaceID = null;
    this.collectionsService
      .getAddressOptions(
        address.query,
        this.partner.Country === 'GB' && address.query.length <= 8
          ? 'GB'
          : '',
      )
      .subscribe((res) => {
        this.addressOptions = res.predictions.map((x) => {
          return { address: x.description, placeID: x.place_id };
        });
      });

  }

  onSelect(event) {
    this.collectionAddrssLoading = true;
    this.address.googlePlaceID = event.placeID;
    this.fullAddress = event.address;
    this.showAddressForm = true;

    this.collectionsService
      .getGooglePlaceInfo(this.address.googlePlaceID)
      .subscribe((placeInfo) => {
        this.setAddressInfo(placeInfo);
      });
    if (!event.placeID) {
      this.getAddressPlaceDetails(true);
    } else {
      //this.getLocationFromAddress(event.address);
    }

  }


  async getAddressPlaceDetails(locationFromAddress = false) {
    await this.collectionsService
      .getAddressOptions(this.fullAddress, `${0},${0}`)
      .subscribe((res) => {
        this.address.googlePlaceID =
          res.predictions && res.predictions.length > 0
            ? res.predictions[0].place_id
            : 'N/A';
        if (locationFromAddress && this.address.googlePlaceID) {
          //this.getLocationFromAddress(
          //  this.fullAddress
          //);
        }
      });
  }


  getLocationFromAddress(address, reset = true) {
    this.collectionsService
      .getLocationFromAddress(
        address +
        (this.partner.Country === 'GB' && this.addressSearch.length <= 8
          ? ', ' + this.addressSearch + ', UK'
          : ''),
      )
      .subscribe(async (res) => {
        // await this.getAddressPlaceDetails(true);
        console.log(res);
        return;

      });
  }

  setAddressInfo(placeInfo) {
    if (placeInfo) {
      var GooglePlace = JSON.parse(placeInfo).result;
      var addressDetails = {
        street_no: null,
        street_address: null,
        city: null,
        country: null,
        postal_code: null,
        latitude: null,
        longitude: null,
        name: "",
        apartment: null
      };
      if (GooglePlace && GooglePlace.address_components) {
        var street_no = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('street_number') > -1;
          })
          .pop();
        if (street_no) {
          addressDetails.street_no = street_no.long_name;
          this.street_no = street_no.long_name;
        }
        var street_address = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('route') > -1;
          })
          .pop();
        if (street_address) {
          addressDetails.street_address = street_address.long_name;
          this.street_address = street_address.long_name;
        }
        var city = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('postal_town') > -1;
          })
          .pop();
        if (city) {
          addressDetails.city = city.long_name;
          this.city = city.long_name;
        }
        if (!city) {
          var city = GooglePlace.address_components
            .filter((x) => {
              return x.types.indexOf('locality') > -1;
            })
            .pop();
          if (city) {
            addressDetails.city = city.long_name;
            this.city = city.long_name;
          }
        }

        var country = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('country') > -1;
          })
          .pop();
        if (country) {
          addressDetails.country = country.long_name;
          this.country = country.long_name;
        }
        var postal_code = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('postal_code') > -1;
          })
          .pop();
        if (postal_code) {
          addressDetails.postal_code = postal_code.long_name;
          this.postal_code = postal_code.long_name;
        }
        addressDetails.latitude = GooglePlace.geometry.location.lat;
        addressDetails.longitude = GooglePlace.geometry.location.lng;

        addressDetails.name = this.customer.AddressType;

        this.address.addressDetails = addressDetails;
        this.address.postalCode = addressDetails.postal_code;
        this.address.apartment = this.apartment;

        if (this.addManually) {
          this.addresses.push(addressDetails);
          this.showAddressForm = !this.showAddressForm;
        }

        this.canUpdate.emit(false);

        if (this.addManually) {
          this.customer.AddressType = "";
          this.customer.Address = ""

          if (!this.updating) {
            this.cyclistService.saveCustomerAddresses(this.partner.ID, this.customer.ID,
              {
                UserID: this.customer.ID,
                IsDefault: this.customer.Addresses && this.customer.Addresses.length > 0 ? false : true,
                Name: addressDetails.name,
                Street_Number: addressDetails.street_no ? addressDetails.street_no : "",
                street_no: addressDetails.street_no ? addressDetails.street_no : "",
                Address_Line_1: addressDetails.street_address,
                Address_Line_2: "",
                City: addressDetails.city,
                State_Province_region: addressDetails.city,
                Postal_Code: addressDetails.postal_code,
                Country: addressDetails.country,
                Apartment: this.apartment
              }).subscribe((res) => {
                this.canUpdate.emit(true);
                this.showAddressForm = !this.showAddressForm;
              });
          }
          else {

          }
        }

        
      }
    }
  }

  editAddress() {
    this.editingAddress.Name = this.customer.AddressType;
    this.editingAddress.Street_Number = this.street_no ? this.street_no : "";
    this.editingAddress.street_no = this.street_no ? this.street_no : "";
    this.editingAddress.Address_Line_1 = this.street_address;
    this.editingAddress.Address_Line_2 = "";
    this.editingAddress.City = this.city;
    this.editingAddress.State_Province_region = this.city;
    this.editingAddress.Country = this.country;
    this.editingAddress.Postal_Code = this.postal_code;
    this.editingAddress.Apartment = this.apartment;
    this.editingAddress.apartment = this.apartment;

    this.cyclistService.updateCustomerAddresses(this.partnerId, this.customer.ID,
      this.editingAddress
      , this.editingAddress.id).subscribe((res) => {
        this.customer.AddressType = "";
        this.customer.Address = "";
        this.street_no = "";
        this.street_address = "";
        this.city = "";
        this.country = "";
        this.postal_code = "";
        this.apartment = "";
        this.addManually = !this.addManually;
        this.editing = false;
        this.showAddressForm = false;
        this.getAddresses();
        this.canUpdate.emit(true);
      });
  }

  getAddresses() {
    this.cyclistService.getCustomerAddresses(this.partnerId, this.customer.ID).subscribe((res) => {
      this.addresses = [];
      this.loading = false;
      for (let i = 0; i < res.length; i++) {
        this.addresses.push({
          name: res[i].name,
          street_no: res[i].street_Number,
          street_address: res[i].address_Line_1,
          city: res[i].city,
          postal_code: res[i].postal_Code,
          country: res[i].country,
          id: res[i].id,
          apartment: res[i].apartment,
          isDefault: res[i].isDefault
        });
      }

    });
  }


  deleteAddresses(address) {
    this.confirmationService.confirm({
      key: 'pos_confirmation',
      rejectVisible: true,
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('general.yes'),
      header: this.translate.instant(
        'bikeshop.workshop.jobcard.manage.notes.confirm_delete',
      ),
      message: this.translate.instant(
        'bikeshop.workshop.jobcard.customer.remove_customer_confirm_header',
      ),
      accept: () => {
        this.cyclistService.deleteCustomerAddresses(this.partnerId, this.customer.ID, address.id).subscribe((res) => {
          const index = this.addresses.findIndex(addr => addr.id === address.id);
          if (index > -1) {
            this.addresses.splice(index, 1);
          }
        });
      },
      reject: () => {
      },
    });

   
  }


  editAddresses(address) {
    this.updating = true;
    this.editing = true;
    this.addManually = !this.addManually;
    this.showAddressForm = true;
    this.canUpdate.emit(false);
    this.customer.AddressType = address.name;
    //this.customer.Address = address.street_no ? address.street_no + " " + address.street_address : address.street_address;
    console.log(address);
    this.street_no = address.street_no;
    this.street_address = address.street_address;
    this.apartment = address.apartment;
    this.city = address.city;
    this.country = address.country;
    this.postal_code = address.postal_code;
    this.editingAddress = address;
  }


  defaultChanged(address, index, event) {
    if (!event.checked) {
      // Prevent unchecking — only another address can replace the default
      address.isDefault = true;
      return;
    }

    // Optimistically update UI
    this.addresses.forEach((addr, i) => {
      addr.isDefault = i === index;
    });

    const payload = {
      UserID: this.customer.ID,
      IsDefault: true,
      Name: address.name,
      Street_Number: address.street_no ? address.street_no : "",
      street_no: address.street_no ? address.street_no : "",
      Address_Line_1: address.street_address,
      Address_Line_2: "",
      City: address.city,
      State_Province_region: address.city,
      Postal_Code: address.postal_code,
      Country: address.country,
      Apartment: address.apartment
    };

    this.cyclistService.updateCustomerAddressesDefault(this.partnerId, this.customer.ID, payload, address.id)
      .subscribe(() => {}, () => {
        // Revert on error
        this.getAddresses();
      });
  }


  addAddressManually() {
    var addressDetails = {
      street_no: this.street_no,
      street_address: this.street_address,
      city: this.city,
      country: this.country,
      postal_code: this.postal_code,
      latitude: null,
      longitude: null,
      name: this.customer.AddressType,
      apartment: this.apartment
    };
    this.canUpdate.emit(false);
    if (!this.updating) {
      this.cyclistService.saveCustomerAddresses(this.partner.ID, this.customer.ID,
        {
          UserID: this.customer.ID,
          IsDefault: this.customer.Addresses && this.customer.Addresses.length > 0 ? false : true,
          Name: addressDetails.name,
          Street_Number: addressDetails.street_no ? addressDetails.street_no : "",
          street_no: addressDetails.street_no ? addressDetails.street_no : "",
          Address_Line_1: addressDetails.street_address,
          Address_Line_2: "",
          City: addressDetails.city,
          State_Province_region: addressDetails.city,
          Postal_Code: addressDetails.postal_code,
          Country: addressDetails.country,
          Apartment: this.apartment
        }).subscribe((res) => {
          this.canUpdate.emit(true);
          this.getAddresses();
        });
    }

    this.addresses.push(addressDetails);
    this.customer.AddressType = "";
    this.customer.Address = "";
    this.street_no = "";
    this.street_address = "";
    this.city = "";
    this.country = "";
    this.postal_code = "";
    this.apartment = "";
    this.addManually = true;
    this.showAddressForm = false;

    
  }


  validateManualAddress() {
    if (!this.street_address) this.street_address = "";
    if (!this.city) this.city = "";
    if (!this.customer.AddressType) this.customer.AddressType = "";

    return !((this.street_address.trim().length > 0) && (this.city.trim().length > 0) && (this.customer.AddressType.trim().length > 0) && this.validateAddressName());
  }

  validateAddressName() {
    if (this.editing) return true;

    var addressTypeTrimmed = this.customer.AddressType.trim().toLowerCase();
    return !this.addresses.some(addr =>
      addr.name && addr.name.trim().toLowerCase() === addressTypeTrimmed
    );
  }



}
